import { render, staticRenderFns } from "./ReportTitle.vue?vue&type=template&id=44aa0257&scoped=true&"
import script from "./ReportTitle.vue?vue&type=script&lang=js&"
export * from "./ReportTitle.vue?vue&type=script&lang=js&"
import style0 from "./ReportTitle.vue?vue&type=style&index=0&id=44aa0257&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa0257",
  null
  
)

export default component.exports
import {QIcon,QBtn,QMenu,QList,QItem,QItemSection,QTooltip,ClosePopup} from 'quasar'
component.options.components = Object.assign({QIcon,QBtn,QMenu,QList,QItem,QItemSection,QTooltip}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
